import React, { useState } from "react";
import "./Product.css";
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
import ShopIcon from "@material-ui/icons/Shop";
import Modal from "@material-ui/core/Modal";
import { useStateValue } from "./StateProvider";
import { Link } from "react-router-dom";

const Product = (props) => {
	let arrstar = [];
	for (let i = 0; i < props.product.rating; i++) {
		arrstar.push(1);
	}

	const [{ basket }, dispatch] = useStateValue();

	const addToBasketHandler = () => {
		// dispatch item to data layer
		dispatch({
			type: "ADD_TO_BASKET",
			item: {
				title: props.product.title,
				image: props.product.image,
				price: props.product.price,
				rating: props.product.rating,
			},
		});
		handleClose();
	};

	const [open, setOpen] = useState(false);

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<div className="product">
			<div className="product__info">
				<p className="product__title">
					{props.product.title.slice(0, 120)}
					{props.product.title.length > 120 ? "..." : ""}
				</p>
				<p className="product__price">
					<small>₹</small> <strong>{props.product.price}</strong>
				</p>
				<div className="product__rating">
					{arrstar.map((star) => (
						<p>⭐️</p>
					))}
				</div>
			</div>

			<img
				src={props.product.image}
				alt={props.product.title}
				onClick={(e) => setOpen(true)}
			/>
			<button onClick={addToBasketHandler}>
				<ShoppingBasketIcon className="product__buttomIcon" />
				Add to Cart
			</button>

			<Modal
				open={open}
				onClose={handleClose}
				className="product__modalContainer"
			>
				<div className="product">
					<div className="product__info modal__style">
						<p className="product__title">{props.product.title}</p>
						<p className="product__price">
							<small>₹</small> <strong>{props.product.price}</strong>
						</p>
						<div className="product__rating">
							{arrstar.map((star) => (
								<p>⭐️</p>
							))}
						</div>
					</div>

					<img src={props.product.image} alt={props.product.title} />
					<div className="button__container">
						<button onClick={addToBasketHandler} className="button__button">
							<ShoppingBasketIcon className="product__buttomIcon" />
							Add to Cart
						</button>
						<Link to="/checkout" style={{ textDecoration: "none" }}>
							<button onClick={addToBasketHandler} className="button__button">
								<ShopIcon className="product__buttomIcon" />
								Buy Now
							</button>
						</Link>
					</div>
				</div>
			</Modal>
		</div>
	);
};

export default Product;
